// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label.fancyCheckboxLabel[data-v-0758a8ce]{padding-left:15px !important;color:#123645 !important}label.fancyCheckboxLabel[data-v-0758a8ce]::before{width:2.4em !important;border-color:#63da2a !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
